export const INTRODUCER_ATTRIBUTE_TYPE = 'user';
export const INTRODUCER_ATTRIBUTE_FIELDS = {
  broker: 'broker',
  brokerName: 'brokerName',
  introducer: 'introducer'
};
